
import { defineComponent } from 'vue'
import Dialog from 'primevue/dialog'
import lovsManagementParamsDialogDescriptor from './LovsManagementParamsDialogDescriptor.json'

export default defineComponent({
    name: 'lovs-management-params-dialog',
    components: { Dialog },
    emits: ['close', 'preview', 'test'],
    props: {
        visible: { type: Boolean },
        dependenciesList: { type: Array },
        mode: { type: String }
    },
    data() {
        return {
            lovsManagementParamsDialogDescriptor
        }
    },
    created() {},
    methods: {}
})
